module.exports = __webpack_public_path__ + "static/img/10.2fda8fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/10.png
// module id = fcw7
// module chunks = 0